import clsx from 'clsx'

import Skeleton from '../../../app/components/Skeleton'
import useCartDrawerOpen from '../../../checkout/hooks/useCartDrawerOpen'
import isDefaultProductCardStyle from '../../../product/utils/isDefaultProductCardStyle'

import styles from './OutletMenuSkeleton.module.scss'

export default function OutletMenuSkeleton() {
  const defaultProductCardStyle = isDefaultProductCardStyle()
  const cartDrawerOpen = useCartDrawerOpen()

  return (
    <>
      <div className={styles.container}>
        <hr />
        <div className={styles.wrapper}>
          {new Array(6).fill(0).map((_, index) => (
            <Skeleton
              className={styles.menuGroupName}
              // eslint-disable-next-line react/no-array-index-key
              key={index}
            />
          ))}
        </div>
        <hr />
        <div className={styles.wrapper}>
          {new Array(3).fill(0).map((_, index) => (
            <Skeleton
              className={styles.subMenuGroupName}
              // eslint-disable-next-line react/no-array-index-key
              key={index}
            />
          ))}
        </div>
        <hr />
      </div>
      <div className={styles.menuListingContainer}>
        {new Array(2).fill(0).map((section, i) => (
          <div
            className={styles.productListContainer}
            // eslint-disable-next-line react/no-array-index-key
            key={i}
          >
            <Skeleton className={styles.groupName} />
            <div
              className={clsx(styles.gridContainer, {
                [styles.gridWithDrawer]: cartDrawerOpen,
              })}
            >
              {new Array(4).fill(0).map((_, index) => (
                <Skeleton
                  className={clsx(styles.productCard, {
                    [styles.imageOnTopStyle]: !defaultProductCardStyle,
                  })}
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
